// extracted by mini-css-extract-plugin
export default {"OtherTweetPageContainer":"OtherTweetPage_OtherTweetPageContainer__WbSBo"};